<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<el-tabs v-model="type" @tab-click="handleClick">
			<el-tab-pane label="基础设置" name="1">
				<el-form ref="form" :model="form_1" v-if="type==1" :label-position="this.layout.is_phone?'top':''" label-width="300px">
				
					<el-form-item :label="item.name" 
					v-for="(item,index) in list">
						 <el-input :placeholder="item.name" type="text" class="w-50"  v-model="item.value_set">
						   
						  </el-input>
					</el-form-item>
					<el-form-item >
						<el-button v-auth="'addSystem'" @click="addOrEdit" type="primary">保存</el-button>
					</el-form-item>
					
				</el-form>
			</el-tab-pane>

		</el-tabs>
	</div>
</template>

<script>
	import common from '@/common/mixins/common.js';
	import tinymce from '@/components/common/tinymce.vue';
	export default {
		components:{
			tinymce
		},
		inject: ['layout', 'app'],
		mixins: [common],
		data() {
			return {
				type: '1',
				xyIndex:0,
				form_1: {},
				preUrl: "user/systemList", //列表地址
				addUrl: "user/addSystem", //修改地址
				tableData: [],
				checkboxGroup1: [],
				list:{},
				content:""
			}
		},
		methods:{
			// 鼠标点击事件
			onClick(e, editor) {
			
			},
			getListResult(e) {
				if(this.type==7){
					this.list = e.list.map(item=>{
						
						item.value_set = item.value_set==1?true:false
						return item
					})
					
					this.list = e.list
				}else{
					
					this.list = e.list
					
				}
				
				
				console.log(this.list)
			},
			handleClick(tab, event) {
				this.list = [];
				this.search = ''
				this.getList()
			},
			
			addOrEdit() {
				this.layout.loading = true;
				this.axios.post(this.addOrEditUrl(), {data:this.list}, {
					token: true
				}).then(res => {
					let all = res.data
					if (all.code == 1) {
						this.$message({
							message:  '修改成功',
							type: 'success'
						});
						
					}
					this.layout.loading = false;
				}).catch(err => {
					this.layout.loading = false;
				})
			},
			// 选择图片
			chooseImage(index) {
				this.app.chooseImage((res) => {
					//console.log(res)
					//this.form.headUrl = ''
					this.$set(this.list[index], 'value_set', res[0].url);
					this.$set(this.list[index], 'url_id', res[0].id);
					//this.form.headUrl = res[0].url
				}, 1)
			}
		},
		
	}
</script>

<style>
	.tox-silver-sink{
		z-index: 2006!important;
	}
</style>
